module.exports = {
    SphereVisit: 'virtualtour.sphere.visit',
    FloorStart: 'virtualtour.floor.start',
    SphereNavigation: 'virtualtour_navigator.selected',
    SphereInteracted: 'virtualtour_sphere.interacted',
    SpherePresented: 'virtualtour_sphere.presented',
    HotSpotDisplayed: 'virtualtour_hotspot.displayed',
    TutorialPresented: 'virtualtour_tutorial.presented',
    TutorialHidden: 'virtualtour_tutorial.hidden',
    NavMenuPresented: 'virtualtour_nav_menu.presented',
    NavMenuFormToggled: 'virtualtour_nav_menu_form.selected',
    NavMenuGroupSelected: 'virtualtour_nav_menu_group.selected',
    NavMenuGroupPresented: 'virtualtour_nav_menu_group.presented',
};
